const allowedPhoneCharsRegExp = /^[0-9+()\-.\s]+$/;

export function cleanPhoneNumber(phoneNumber) {
  const value = typeof phoneNumber === 'string' ? phoneNumber.trim() : phoneNumber ? String(phoneNumber) : '';
  if (!allowedPhoneCharsRegExp.test(value)) return value;
  const digits = value.replace(/\D/g, '');
  return digits.length > 10 ? digits.slice(-10) : digits;
}

export function formatPhoneNumber(phoneNumber) {
  // const cleaned = ('' + phoneNumber).replace(/\D/g, '');
  // const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  const match = phoneNumber.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    // const intlCode = (match[1] ? '+1 ' : '');
    return ['+1 ', '(', match[2], ') ', match[3], ' ', match[4]].join('');
  }
  return null;
}
